/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Policy_BodyInputs */

const en_price_page_policy_body = /** @type {(inputs: Price_Page_Policy_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you book, you see until when you can cancel for free. You cancel in one tap in your bookings.`)
};

const pl_price_page_policy_body = /** @type {(inputs: Price_Page_Policy_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zanim zarezerwujesz, widzisz, do kiedy odwołasz bez opłat. Odwołujesz jednym dotknięciem w swoich rezerwacjach.`)
};

/**
* | output |
* | --- |
* | "Before you book, you see until when you can cancel for free. You cancel in one tap in your bookings." |
*
* @param {Price_Page_Policy_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_policy_body = /** @type {((inputs?: Price_Page_Policy_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Policy_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_policy_body(inputs)
	return en_price_page_policy_body(inputs)
});